import { get, set, del } from "idb-keyval";
import type { PersistedClient, Persister } from "@tanstack/react-query-persist-client";

const IDB_KEY = "rq-cache";

export const idbPersister: Persister = {
  persistClient: async (client: PersistedClient) => {
    try {
      await set(IDB_KEY, client);
    } catch {
      /* fail open: persistence is best-effort */
    }
  },
  restoreClient: async () => {
    try {
      return await get<PersistedClient>(IDB_KEY);
    } catch {
      // Corrupted/unavailable IDB — wipe and continue without cache.
      try { await del(IDB_KEY); } catch { /* ignore */ }
      return undefined;
    }
  },
  removeClient: async () => {
    try {
      await del(IDB_KEY);
    } catch {
      /* ignore */
    }
  },
};

/** Wipe the persisted React Query cache from IndexedDB */
export async function clearPersistedCache(): Promise<void> {
  try {
    await del(IDB_KEY);
  } catch {
    /* ignore */
  }
}
